// extracted by mini-css-extract-plugin
export default {"badge":"Platforms_badge__CdM1F"};